import React, { useState, useRef, useEffect, useContext } from 'react'
import TPSSectionPage from './TPSSectionPage';
import LeftMenu from '../../components/LeftMenu';
import ButtonSectionFactory from '../../../src/components/buttons/ButtonSectionFactory';
import { useOktaAuth } from '@okta/okta-react';
import {getAllCountryList, getAgreementByCountry} from '../../services/survey.service'; 
import {getTPSResponseById, getTPSResponsesByAssignment, deleteTpsResponseByResponseId} from '../../services/tps.service';
import { Context } from  "../../components/tps/TpsContext";
import SurveyTitle from '../../components/SurveyTitle';
import { Grid, TableRow,TableCell,IconButton,Radio,Card,Box,CardContent,Typography,FormControlLabel, Button} from '@deere/fuel-react';
import { SVGIconDelete } from '../../components/SVGIcon';
import { useTranslation } from "react-i18next";
import { dateConvert } from '../../utils/utils'
import CustomAlert from '../../components/CustomAlert'
import CampaignClosedAlert from '../../components/CampaignClosedAlert'
import { useHistory} from 'react-router';
import useTpsContext from '../../hooks/useTpsContext';
import { ModalGeneric } from '../../components/ModalGeneric';
import { TPS_COMPONENT_CODE_SECTIONS, TPS_RESPONSE_STATUSES, SCBM_STATES_CAMPAIGN, TPS, TPSMEX } from '../../utils/surveyLiterals';
import LeftRelatedLinks from '../../components/LeftRelatedLinks';
import { getHelpDocPdf } from '../../services/tpsmex.service';

export const TPSSurveyPage = ({  survey, campaignAssigned, setSurvey}) => {
    const history = useHistory();
    const sections = survey.sections;
    let sectionsTitles = [...sections.map((section,index)=> section.description)]
    const sectionsRef = useRef([new Array(sectionsTitles.length)]);
    const [validated, setValidated] = useState(false)
    let questionsToValidate 
    const [actLink, setActLink] = useState(new Array(sectionsTitles.length).fill(""));
    const { authState } = useOktaAuth();  
    const {tpsContext} = useContext(Context);
    const[countryList, setCountryList]= useState(undefined);   
    const [agreements, setAgreements]= useState(null);
    const [errorCard, setErrorCard] = useState([]);
    const [successMessage, setSuccessMessage] = useState(undefined);
    const [tpsResponses,setTpsResponses] = useState(undefined);
    const [ isSubmitted, setIsSubmitted ] = useState(false);
    const { t } = useTranslation();
    const form = document.forms.tpsForm;
    const useTps = useTpsContext(Context);
    const [showValidationModal, setShowValidationModal] = useState(false);
    const [opcTodelete, setOpcTodelete] = useState(null);
    const [opcSelected, setOpcSelected] = useState(null);
    const [tpsResponseSelected,setTpsResponseSelected] = useState(undefined);
    const [deleteResponseMessage, setdeleteResponseMessage] = useState(null);
    const [selectionModel, setSelectionModel] = useState([]); //TPSMEX
    const [editedPartCountries, setEditedPartCountries] = useState([]); //TPSMEX
    const agreementQuestionIds = survey.code === TPS ? sections.filter(section => section.code === TPS_COMPONENT_CODE_SECTIONS.AGREEMENT_SEC)[0].questions.map(question => question) : [];
    const [url, setUrl] = useState(null);
    const [navMenuHeight, setNavMenuHeight] = useState(0);

    const isCampaignClosed = campaignAssigned && campaignAssigned.status === SCBM_STATES_CAMPAIGN.CLOSED;

    function clearErrors(){
        setValidated(false);
        setErrorCard([]);
        setSuccessMessage(undefined);
    } 
    
    function review(response){
        history.push({
            pathname: '/tps/review',
            state: {
                previous: '/tps',
                assignmentId: campaignAssigned.assignments[0].id,
                response: response,
                survey: survey
            }
        })
    }

    const resetForm = () => {
        setEditedPartCountries([]);
        setSelectionModel([]);
        setOpcSelected(null);
        setAgreements(null);
        setTpsResponseSelected(null);
        useTps.updateContext(null);
    }

    const deleteResponse = () => {
        try {
            deleteTpsResponseByResponseId(opcTodelete,authState.accessToken.accessToken, survey.code).then((response) => {
                if(response && response.numberResponsesDeleted && response.numberResponsesDeleted >0){
                    getTPSResponsesByAssignment(campaignAssigned.assignments[0].id,authState.accessToken.accessToken, survey.code).then(response=>{
                        if(response){  
                            setTpsResponses(response);
                        }
                    });
                    setSuccessMessage(t('tps_msg_success_delete'));
                }else{                    
                    setErrorCard(t('tps_msg_response_not_found'));
                    window.scrollTo(0, 0);        
                }
                setShowValidationModal(false);
            })
        } catch (error) {
            console.log(error);
            setShowValidationModal(false);
            setErrorCard(t('tps_msg_response_not_found'));
            window.scrollTo(0, 0);
        }
    }

    function setResponseSelected(e,response){
        getTPSResponseById(response.id, authState.accessToken.accessToken, survey.code)
            .then((res) => {
                setOpcSelected(e.target.value);
                setTpsResponseSelected(response);
                res.tpsResponseSelected = response;
                if(!res.country){
                    setAgreements(null);
                }
                useTps.updateContext(res);
        }).catch(error => {
            console.log(error)
            setErrorCard(t('tps_msg_response_not_found'));
        })
    }
    

    function getTableRows(data){
        if(data){
            return data.map((row,index)=>
            
                <TableRow key={index}>
                    <TableCell>
                        <FormControlLabel
                            control={<Radio name="responseSelected" id='responseSelected' value={row.id} checked={tpsContext.id===row.id?true:false} />}
                            label=""
                            onChange={(e) => setResponseSelected(e, row)}
                        />
                    </TableCell>
                    <TableCell>
                        {
                            row.status === TPS_RESPONSE_STATUSES.SUBMITTED ?
                                <Button variant="text" onClick={(e) => review(row)} >{row.responseName}</Button>
                                : row.responseName
                        }
                    </TableCell>
                    <TableCell align="right">{row.numberOfParts}</TableCell>
                    <TableCell align="right">{dateConvert(row.lastUpdatedTs)}</TableCell>
                    <TableCell align="right">{row.updatedBy}</TableCell>
                    <TableCell align="right">{row.status}</TableCell>
                    <TableCell align="right">
                        <IconButton aria-label="delete" onClick={e=>{setOpcTodelete(row.id); buildModalMessage(row); setShowValidationModal(true)}} disabled={disableDeleteIcon()}>
                            <SVGIconDelete />
                        </IconButton>
                    </TableCell>
                </TableRow>)
        }else{
            return null;
        }
    }

    function disableDeleteIcon(){
        return campaignAssigned && campaignAssigned.status === SCBM_STATES_CAMPAIGN.CLOSED ?  true : false;
    }

    function getLastResponse(data){
        if(data){
            const tmpArray = [...data];
            tmpArray.sort(function(a,b){
                return new Date(b.lastUpdatedTs) - new Date(a.lastUpdatedTs);
              });
            return tmpArray[0];
        }else{
            return null;
        }
    }

    useEffect(()=>{    
        if(!countryList){
            getAllCountryList(authState.accessToken.accessToken).then(response => {
               if(response){
                 setCountryList(response);
                }
            })
        } 
      
        tpsContext.country && getAgreementByCountry(tpsContext.country,authState.accessToken.accessToken).then(response => {
            if(response){  
                setAgreements(response);               
            }
        }); 
    },[tpsContext.country])

    useEffect(()=>{
        const assigmentId = campaignAssigned && campaignAssigned.assignments[0] ? campaignAssigned.assignments[0].id : null;
        if(assigmentId){
            getTPSResponsesByAssignment(assigmentId,authState.accessToken.accessToken, survey.code).then(response=>{
                if(response){  
                    setTpsResponses(response);
                }
            });
        }
    },[authState.accessToken.accessToken, campaignAssigned])

    useEffect(()=>{
        if(survey && survey.code === TPSMEX){
            getHelpDocPdf(authState.accessToken.accessToken).then(async (response) => {
                if(response.status === 200){
                    const blob = await response.blob();
                    const url = window.URL.createObjectURL(blob)
                    setUrl(url)
                }
            })
            .catch((err) => {
               console.log(err)
            });
        }
    }, [])

    const buildModalMessage = (response) => {
        const {assignments} = campaignAssigned;
        const supplierNumber = assignments.filter( assignment => assignment.id === response.campaignAssignmentId);
        const message = `${t('tps_msg_delete_response')}\n ${t('tps_msg_delete_response_number', {responseId: response.id, supplierNumber: supplierNumber[0].supplierNumber})}`
        setdeleteResponseMessage(message);
    }
    
    const showErrorCard = <>
        <Card className='p-2 mb-2 bg-danger'>
            <CardContent className="uxf-card-body-table">
                <Typography className='pb-3 text-white'>
                    {
                        !(errorCard && errorCard.length > 0 && errorCard[0].includes('saving')) ?t('lbl_error_survey_validation'):''
                    }
                </Typography>
                {
                    errorCard.map((error, index) =>
                        <div key={index}>
                            <li className='text-white'>{error}</li>
                        </div>
                    )
                }
            </CardContent>
        </Card>
        <br />
    </>
    return (<><Grid container>
                <Grid item xs={12}>
                    <SurveyTitle survey={survey} assignment={campaignAssigned.assignments[0]} latestResponse={getLastResponse(tpsResponses)} endDate={campaignAssigned.endDate} />
                </Grid>
                <Grid item xs={12} md={2.5}>
                    <LeftMenu actLink={actLink} survey={survey} isNewFrameWork setNavMenuHeight={setNavMenuHeight}></LeftMenu>
                    {survey && survey.code === TPSMEX && <LeftRelatedLinks surveyCode={survey.code} url={url} navMenuHeight={navMenuHeight}/>}
                </Grid>
                <Grid item xs={12} md={9.5}>
                    <Box>
                        {
                            errorCard.length > 0 ? showErrorCard : null
                        }
                        {
                            successMessage ?
                                <CustomAlert accessibilityLabel='success' variant='success' title={successMessage} />
                                : null
                        } 
                        <CampaignClosedAlert campaign={campaignAssigned} />
                    </Box>
                    <form noValidate validated={validated} id='tpsForm'>
                        <fieldset disabled={isCampaignClosed} style={{ border: 'none', padding: 0, margin: 0 }}>
                        {                        
                            sections.sort((a,b) => (a.showOrder > b.showOrder)? 1 : -1).map((section,index) =>
                                <div key={index} ref={el => sectionsRef.current[index] = el}>
                                    <TPSSectionPage 
                                        section={section} 
                                        survey={survey} 
                                        questionsToValidate={questionsToValidate} 
                                        campaign={campaignAssigned} 
                                        countryList={countryList} 
                                        agreements={agreements} 
                                        tpsResponses={getTableRows(tpsResponses)}
                                        isSubmit={isSubmitted} 
                                        setIsSubmitted={setIsSubmitted} 
                                        resetForm={resetForm}
                                        opcSelected={opcSelected} 
                                        agreementQuestionIds={agreementQuestionIds}
                                        selectionModel={selectionModel} 
                                        setSelectionModel={setSelectionModel}
                                        editedPartCountries={editedPartCountries} 
                                        setEditedPartCountries={setEditedPartCountries} 
                                    />
                                </div>
                            )
                        }
                        </fieldset>
                        {!isCampaignClosed && <ButtonSectionFactory campaign={campaignAssigned} clearFunction={clearErrors} survey={survey} code={survey.code} setSurvey={setSurvey} 
                            setErrorCard={setErrorCard} setSuccessMessage={setSuccessMessage} setTpsResponseSelected={setTpsResponseSelected} tpsResponseSelected={tpsResponseSelected} isSubmit={isSubmitted} setIsSubmitted={setIsSubmitted} errorCard={errorCard}
                            setValidated={setValidated} sections={sections} tpsForm={form} setTpsResponses={setTpsResponses} opcSelected={opcSelected}/>}
                    </form>
                </Grid>                
            </Grid>
            <ModalGeneric showModal={showValidationModal}  setShowModal ={setShowValidationModal} labelBtnPrimary={t('t2_remove')}  labelBtnSecondary={t('btn_cancel')}   handleSubmit={deleteResponse}  msgModal={deleteResponseMessage}   titleModal={t('t2_remove')}/>
            </>
    )
}